<div class="absolute inset-0 z-50 bg-[#f9f7f5] flex items-center justify-center p-4 animate-fade-in">
    <div class="w-full max-w-md bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
        <!-- Login Header -->
        <div class="bg-[#b13e90] p-8 text-center">
            <div class="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 backdrop-blur-sm">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.5">
                    <path d="M9.35 15.65a3.97 3.97 0 0 1 1.96-3.32V8a5 5 0 0 1 2.33-4.23l1.8-1.04A1 1 0 0 0 15 2H9a1 1 0 0 0-.44.73l1.8 1.04A5 5 0 0 1 12.7 8v4.33a3.97 3.97 0 0 1 1.95 3.32v.2a2 2 0 0 1-2 2H11.3a2 2 0 0 1-2-2v-.2z"/>
                    <path d="M6 20h12"/>
                    <path d="M8 20v2h8v-2"/>
                </svg>
            </div>
            <h1 class="text-3xl font-bold text-white mb-2">{{'appTitle' |translate}}</h1>
            <p class="text-[#b13e90]/20 text-white/80 text-sm font-medium">{{ 'loginSubtitle'|translate }}</p>
        </div>

        @switch (isMfaStep()) {
            @case (false) {
                <!-- Login Form -->
                <form class="flex flex-col gap-4" [formGroup]="logInForm" (submit)="sendLogin()">
                    <div class="p-8 space-y-6" >
                        <div class="space-y-4">
                            <div>
                                <label class="block text-xs font-bold text-gray-400 uppercase tracking-widest mb-1.5">{{ 'emailLabel'|translate }}</label>
                                <input type="email" [formControl]="formControls.email" appLowercase appTrim class="w-full bg-gray-50 border border-gray-200 rounded-lg p-3 outline-none focus:border-[#b13e90] focus:bg-white transition-all text-gray-800 placeholder:text-gray-300" placeholder="guest@example.com" required>
                            </div>
                            <div>
                                <label class="block text-xs font-bold text-gray-400 uppercase tracking-widest mb-1.5">{{ 'passwordLabel'|translate }}</label>
                                <input type="password" [formControl]="formControls.password" class="w-full bg-gray-50 border border-gray-200 rounded-lg p-3 outline-none focus:border-[#b13e90] focus:bg-white transition-all text-gray-800 placeholder:text-gray-300" placeholder="••••••••">
                            </div>
                        </div>
                        <button type="submit" class="w-full bg-[#b13e90] hover:bg-[#8e3173] text-white py-3.5 rounded-xl font-bold shadow-lg shadow-[#b13e90]/20 active:scale-[0.98] transition-all" [disabled]="formState().isSubmitted||formState().isLoading">
                            {{'loginBtn'|translate }}
                        </button>
                    </div>
                </form>
            }
            @case (true) {
                <form class="flex flex-col gap-4" [formGroup]="mfaForm" (submit)="sendMfa()">
                    <div class="p-8 space-y-6 animate-fade-in">
                        <div>
                            <h2 class="text-xl font-bold text-gray-900">{{ 'mfaTitle'|translate }}</h2>
                            <p class="text-sm text-gray-500 mt-1">{{ 'mfaSubtitle'|translate }}</p>
                        </div>
                        @if (QRCode().length>0){
                            <h3 class="text-sm font-bold text-gray-900 m-3" >{{ 'qrcode'|translate }}</h3>
                            <div class="flex justify-center">
                                <img src="{{QRCode()}}" alt="QR Code">
                            </div>
                        }
                        <div>
                            <label class="block text-xs font-bold text-gray-400 uppercase tracking-widest mb-1.5">{{ 'mfaCodeLabel'|translate }}</label>
                            <input type="text" inputmode="numeric" [formControl]="mfaControls.mfa_code" class="w-full bg-gray-50 border border-gray-200 rounded-lg p-3 outline-none focus:border-[#b13e90] focus:bg-white transition-all text-gray-800 placeholder:text-gray-300" [placeholder]="'mfaCodePlaceholder'|translate">
                            <p class="text-xs text-gray-400 mt-2">{{ 'mfaHelpText'|translate }}</p>
                        </div>
                        <div>
                            <label class="block text-xs font-bold text-gray-400 uppercase tracking-widest mb-1.5">{{ 'MFAFlagLabel'|translate }}</label>
                            <input type="checkbox"  [formControl]="mfaControls.mfa_flag" class="w-full bg-gray-50 border border-gray-200 rounded-lg p-3 outline-none focus:border-[#b13e90] focus:bg-white transition-all text-gray-800 placeholder:text-gray-300" >
                        </div>
                        <button type="submit" [disabled]="formState().isLoading" class="w-full bg-[#b13e90] hover:bg-[#8e3173] text-white py-3.5 rounded-xl font-bold shadow-lg shadow-[#b13e90]/20 active:scale-[0.98] transition-all">
                            {{ 'mfaVerifyBtn'|translate }}
                        </button>
                    </div>
                </form>
            }
        }

        <!-- Footer Lang Selection for Login -->
        <div class="bg-gray-50 p-4 border-t border-gray-100 flex justify-center gap-4">
            <app-language-selector></app-language-selector>
        </div>
    </div>
</div>
